module.exports = __webpack_public_path__ + "img/20190703152219699.591adac0.png";